module.exports = __webpack_public_path__ + "img/img_serve_03@2x.7ef4c463.png";